module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box mb-2"
  }, [(!_vm.editing) ? _c('section', {
    staticClass: "d-flex flex-space-between align-items-center mb-4 timestamp-section"
  }, [_c('h2', [_vm._v(_vm._s(_vm.comment.dimension))]), _vm._v(" "), _c('a', {
    staticClass: "tag is-primary play-tag no-select",
    on: {
      "click": function($event) {
        _vm.jumpToTime(_vm.comment.start_time)
      }
    }
  }, [_c('PlayIcon'), _vm._v("\n      " + _vm._s(_vm.prettyTimeStamp(_vm.comment.start_time, _vm.comment.end_time)))], 1)]) : _c('section', [_c('div', {
    staticClass: "mb-2 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeMins),
      expression: "startTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "01",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeSecs),
      expression: "startTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "21",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeSecs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "time-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeMins),
      expression: "endTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "09",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeSecs),
      expression: "endTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "57",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeSecs = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "select mb-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.dimension),
      expression: "comment.dimension"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.comment, "dimension", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.dimensions), function(dim) {
    return _c('option', [_vm._v(_vm._s(dim))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v("I see...")]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "answer-blocks"
  }, [_vm._v(_vm._s(_vm.comment.text_see))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.text_see),
      expression: "comment.text_see"
    }],
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": (_vm.comment.text_see)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comment, "text_see", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v("I notice...")]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "answer-blocks"
  }, [_vm._v(_vm._s(_vm.comment.text_notice))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.text_notice),
      expression: "comment.text_notice"
    }],
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": (_vm.comment.text_notice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comment, "text_notice", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v("I wonder...")]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "answer-blocks"
  }, [_vm._v(_vm._s(_vm.comment.text_wonder))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.text_wonder),
      expression: "comment.text_wonder"
    }],
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": (_vm.comment.text_wonder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comment, "text_wonder", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "flex-space-between"
  }, [_c('section', {
    staticClass: "align-items-center"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "button is-info is-small",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('a', {
    staticClass: "mr-4",
    on: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('a', {
    staticClass: "mr-4",
    on: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showDelete = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("prettyDate")(_vm.comment.created_on)))])]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "title": "Deleting Comment",
      "message": "Are you sure you want to delete this comment?",
      "show": _vm.showDelete,
      "loading": _vm.deleting
    },
    on: {
      "cancel": function($event) {
        _vm.showDelete = false
      },
      "confirm": function($event) {
        _vm.deleteComment()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-9776114c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArtFormComment.vue
// module id = 1076
// module chunks = 0